import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import { BUTTON_SIZE, BUTTON_VARIANTS } from '../../../components/shared/button/button.constants'
import Button from '../button/button.component'
import PlusIcon from '@hapana/shared/web/styles/assets/svgs/plus-small.svg'
import Switch from '../../../components/shared/switch/switch.component'
import { SWITCH_TYPES } from '../../../components/shared/switch/switch.constants'
import { commonStyles } from '../../../styles/common.styles'

import { styles } from './modal-group.styles'

const ModalGroup = ({ children, title, sx, actionConfig, secondaryActionConfig, description }) => {
  return (
    <Box>
      <Box sx={styles.titleContainer}>
        <Box>
          <Typography sx={styles.title}>{title}</Typography>
          {description && (
            <Typography variant="small" color="gray.64">
              {description}
            </Typography>
          )}
        </Box>
        <Box sx={commonStyles.spaceBetweenFlexRow}>
          {secondaryActionConfig && (
            <Switch
              label={secondaryActionConfig.label}
              name="Label"
              reversedLabel
              type={SWITCH_TYPES.LABEL}
            />
          )}
          {actionConfig && (
            <Button
              onClick={actionConfig.action}
              label={actionConfig.label}
              size={BUTTON_SIZE.LARGE}
              startIcon={actionConfig.icon !== undefined ? actionConfig.icon : PlusIcon}
              variant={BUTTON_VARIANTS.TEXT}
              disabled={actionConfig.disabled}
              sx={styles.actionConfig}
            />
          )}
        </Box>
      </Box>
      <Box sx={[styles.content, sx]}>{children}</Box>
    </Box>
  )
}
export default ModalGroup

ModalGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  actionConfig: PropTypes.shape({
    label: PropTypes.string.isRequired,
    action: PropTypes.func,
    icon: PropTypes.elementType,
    disabled: PropTypes.bool,
  }),
  secondaryActionConfig: PropTypes.shape({
    label: PropTypes.string.isRequired,
    action: PropTypes.func,
    disabled: PropTypes.bool,
  }),
}
